import Arrows from "assets/svg/Arrows.svg";
import Arrows2 from "assets/svg/Arrows-2.svg";
import CircleWavyCheck from "assets/svg/circle-wavy-check.svg";
import CloudArrowUp from "assets/svg/cloud-arrow-up.svg";
import MagnifyingGlassPlus from "assets/svg/magnifying-glass-plus.svg";
import UserPlus from "assets/svg/user-plus.svg";
import React, { FC } from "react";

interface Props {}

const IntroducingScholarsWays: FC<Props> = ({}) => {
  return (
    <section className="px-[4%] py-8 lg:px-[12%]">
      <h3 className="mb-10 text-center text-base font-bold md:text-lg lg:mb-16 2xl:text-3xl">
        مراحل معرفی دانش‌پذیران دادبانان به بازارکار
      </h3>
      <div className="xl:pr-[10%]">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4 xl:gap-4">
          <div className="">
            <div className="flex items-center gap-4">
              <div className="mx-auto rounded-full bg-[#0577AF1A] p-5 xl:mx-0">
                <CircleWavyCheck className="text-blue-550" />
              </div>
              <Arrows className="-mt-10 hidden text-[#0577AF66] xl:block" />
            </div>
            <p className="relative mt-2 text-center text-base md:text-lg xl:-right-[22%] xl:text-right">
              1. استعدادیابی و مشاوره شغلی
            </p>
          </div>
          <div className="">
            <div className="flex items-center gap-4">
              <div className="mx-auto rounded-full bg-[#0577AF1A] p-5 xl:mx-0">
                <CloudArrowUp className="text-blue-550" />
              </div>
              <Arrows2 className="mt-10 hidden w-full text-[#0577AF66] xl:block" />
            </div>
            <p className="relative mt-2 text-center text-base md:text-lg xl:-right-[16%] xl:text-right">
              2. آموزش های کاربردی
            </p>
          </div>
          <div className="">
            <div className="flex items-center gap-4">
              <div className="mx-auto rounded-full bg-blue-550 p-5 xl:mx-0">
                <MagnifyingGlassPlus className="text-white" />
              </div>
              <Arrows className="-mt-10 hidden w-full text-[#0577AF] xl:block" />
            </div>
            <p className="relative mt-2 text-center text-base md:text-lg xl:-right-[11%] xl:text-right">
              3. ارزیابی تخصصی
            </p>
          </div>
          <div className="">
            <div className="flex items-center">
              <div className="mx-auto rounded-full bg-[#0577AF1A] p-5 xl:mx-0">
                <UserPlus className="text-blue-550" />
              </div>
            </div>
            <p className="relative mt-2 text-center text-base md:text-lg xl:-right-[26%] xl:text-right">
              4. معرفی به بازار کار و ارتقای شغلی
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroducingScholarsWays;
